import React, { Component } from "react";
import { MDBContainer } from "mdb-react-ui-kit";

import "../stylesheets/main.css";

import UploadMasterData from "./upload-master-data";
import GenerateReports from "./generate-reports";

class Admin extends Component {
   state = {
      showComponent: ""
   }

   handleAdminSelect = () => {
      const index = document.getElementsByClassName("admin-select")[0].selectedIndex;
      if (index === 0) {
         this.setState({ showComponent: "" });
      } else if (index === 1) {
         this.setState({ showComponent: "m" });
      } else if (index === 2) {
         this.setState({ showComponent: "g" });
      }
   };

   render() {
      return (
         <MDBContainer fluid>
            <div className="mt-5 d-flex flex-column align-items-center">
               <strong className="mb-1">Please select what you want to do</strong>
               <select className="admin-select text-center" onChange={this.handleAdminSelect}>
                  <option value="select">-- Select --</option>
                  <option value="master-data">Upload Master Data</option>
                  <option value="generate-reports">Generate Reports</option>
               </select>
            </div>

               {this.state.showComponent === "m" && <UploadMasterData />}
               {this.state.showComponent === "g" && <GenerateReports />}

         </MDBContainer>
      );
   }
}

export default Admin;
